module.exports = __webpack_public_path__ + "img/scene-porch-main.3e82ff53.jpg";